import React, { useEffect } from 'react';

import { Container } from '@mui/material';
import { observer } from 'mobx-react';

import classes from './NgzEntityFlow2024Setup.module.scss';
import {
  LbStepper,
  StepOption,
} from '../../../shared/components/steppers/LbStepper/LbStepper';
import { angularizeWithProviders } from '../../../shared/providers';
import { setupEntityStore } from '../../stores/setupEntityStore';
import { BusinessInfoStep } from './containers/BusinessInfoStep/BusinessInfoStep';
import { InBodySetupStep } from './containers/InBodySetupStep/InBodySetupStep';
import { SetupLoginInfo } from './containers/SetupLoginInfo/SetupLoginInfo';
import { PaymentTypeStep } from './containers/PaymentTypeStep/PaymentTypeStep';
import { PaymentStep } from './containers/PaymentStep/PaymentStep/PaymentStep';
import { solutionsStore } from '../../../shared/stores/solutionsStore';
import { UnavailableSolutionError } from '../../../shared/containers/NgzUnavailableSolutionError/NgzUnavailableSolutionError';

const NgzEntityFlow2024Setup = observer(() => {
  const { activeSolutionFlags, activeSolution } = solutionsStore;
  const { stepperMethods, setDefaultValues } = setupEntityStore;
  const { activeStep } = stepperMethods;

  useEffect(() => {
    return () => setDefaultValues();
  }, []);

  const stepsOptions: StepOption[] = [
    {
      label: 'Business Info',
      step: <BusinessInfoStep />,
    },
    {
      label: 'InBody',
      step: <InBodySetupStep />,
    },
    {
      label: 'Settings - Payment Type',
      step: <PaymentTypeStep />,
    },
    {
      label: 'Payment',
      step: <PaymentStep />,
    },
    {
      label: 'Complete setup',
      step: <SetupLoginInfo />,
    },
  ];

  if (activeSolutionFlags.CHALLENGE) {
    return <UnavailableSolutionError activeSolution={activeSolution} />;
  }

  return (
    <Container>
      <h2 className={classes.title}>Add a New Entity</h2>
      <LbStepper
        stepsArr={stepsOptions}
        activeStep={activeStep}
        className={classes.stepper}
      />
    </Container>
  );
});

angularizeWithProviders(NgzEntityFlow2024Setup, 'ngzEntityFlow2024Setup', {});

export { NgzEntityFlow2024Setup };
